export class LogHelper {
  /**
   * Info
   */
  public static WriteLog(message: any) {
    console.log("[Info]" + message);
  }

  /**
 * console
 */
  public static Console(message: any) {
    console.log("[Console]" + message);
  }

  /**
   * Warn
   */
  public static Warn(message: any) {
    console.warn("[warn]" + message);
  }

  /**
   * Error
   */
  public static Error(message: any) {
    console.error("[error]" + message);
  }

  /**
   * Print
   */
  public static Print(message: any) {
    console.info("[print]" + message);
  }

  /**
   * 狂扫失败日志单独记录(到车)
   */
  public static LogForCrazy(message: any) {
    console.info("[Crazy]" + message);
  }

  /**
   * 统计数据，单独统计过了多少票件
   */
  public static StatisticsLog(message: any) {
    console.info("[Statistics]" + message);
  }
  /**
   * 统计数据，单独统计过了多少票件
   */
  public static VoiceLog(message: any) {
    console.info("[Voice]" + message);
  }


}
